import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Button, Card } from "react-bootstrap";
import getAgriChatData from "../modals/agrichatmodal/get-agrichat-modal"; // Assuming this function fetches your modal data
import axios from "axios";
import AgriChatDoctorList from "../components/AgriChatDoctorList";
import ChatLoader from "../components/ChatLoader";
import Header_packages_chat from "../components/Header_package_chat";
import Swal from "sweetalert2";
import { useLoading } from "../contexts/LoadingContext";
import "./Agri-Doctor-Chat.css";
import AgriChatPrescription from "./agri-chat-prescription";
import { useLocation } from "react-router-dom";
import { checkAgri } from "../services/api";
import getPakistanGreeting from "../components/rsachat/greetingMessage";

const AgriDocChat = () => {
  const [showList, setShowList] = useState(false);
  const [showConsultation, setShowConsultation] = useState(false);

  const [messages, setMessages] = useState([]); // Store all chat messages
  const messagesEndRef = useRef(null); // Ref to scroll to the end of the chat
  const [userData, setUserData] = useState(null); // Store user data from sessionStorage
  const [customerNumber, setCustomerNumber] = useState(null); // Store customer number
  const [loading, setLoading] = useState(false);
  const [diseasename, setdiseasename] = useState(null);
  const [sideimage, setSideImage] = useState("/doctorassistant/dia.jpg");
  const [expandedMessages, setExpandedMessages] = useState({});
  const [healthData, setHealthData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const openId = params.get("openId");
  const isBack = params.get("isBack") === "true";

  const handleReadMoreClick = (index) => {
    setExpandedMessages((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle the state for this specific message
    }));
  };

  const checkAgriStatus = async (openId) => {
    try {
      const response = await checkAgri(openId);
      setHealthData(response);
      return response;
    } catch (err) {
      console.error("Insurance check error:", err);
      setError(err.message);
      return null;
    }
  };

  useEffect(() => {
    const verifyAgriAuth = async () => {
      try {
        if (isBack) {
          console.log("Skipping authentication due to isBack being true");
          await loadData("start");
          return;
        }

        if (!openId) {
          console.log("No openId found, proceeding with authentication");
          authenticateUser();
          return;
        }

        const response = await checkAgriStatus(openId);
        console.log("Insurance Status:", response);

        if (response && response.openId) {
          console.log("Valid user data found, setting session");
          sessionStorage.setItem("user", JSON.stringify(response));

          setUserData(response);
          await loadData("start");
        } else {
          console.log(
            "No valid user data found, proceeding with authentication",
          );
          authenticateUser();
        }
      } catch (error) {
        console.error("Error during insurance verification:", error);
        authenticateUser();
      }
    };

    verifyAgriAuth();
  }, [location.search]);

  const authenticateUser = () => {
    const scopes = [
      "USER_MSISDN",
      "USER_NAME",
      "OPEN_ID",
      "UNION_ID",
      "USER_BIRTHDAY",
    ];

    const getUserAuthCodeResult = (jsonResult) => {
      const result = JSON.parse(jsonResult);
      try {
        if (result.status === "SUCCESS") {
          const form = new FormData();
          form.append("value", result.authCode);
          form.append("apikey", "Agri");
          // form.append("value", 'eb6fede2361ed929cb0f53f5f643ec06ffc312b0');

          axios
            .post(
              "https://miniappeasypaisa.webddocsystems.com/public/api/v1/agri-auth",
              form,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            )
            .then((response) => {
              if (response.data.openId) {
                sessionStorage.setItem("user", JSON.stringify(response.data));
                setUserData(response.data);
                setTimeout(async () => {
                  await loadData("start");
                }, 2000);
              } else {
                Swal.fire({
                  icon: "info",
                  allowOutsideClick: false,
                  title: "Something went wrong. Please try again later!",
                  confirmButtonText: "Retry",
                }).then(() => {
                  authenticateUser();
                });
              }
              // sessionStorage.setItem("user", JSON.stringify(response.data));
              // setUserData(response.data);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          Swal.fire({
            allowOutsideClick: false,
            title: "Please Share the information for Services",
            confirmButtonText: "Retry",
          }).then((result) => {
            if (result.isConfirmed) {
              window.mp.getUserAuthCode(scopes);
            } else {
              console.log("User denied the request");
            }
          });
        }
      } catch (error) {
        console.error("Error fetching doctor profile:", error);
      }
    };

    window.mp.getUserAuthCode(scopes);

    window.getUserAuthCodeResult = getUserAuthCodeResult;
  };

  useEffect(() => {
    let item = {
      id: 1,
      name: "Start Text",
      type: "text",
      options: [
        {
          id: 40012,
          text: "Connect to the Agri Expert",
          name: "Connect to the Agri Expert",
          price: "",
          type: "doctor",
          desc: "I’d like to connect with a doctor.",
        },
        {
          id: 40012,
          text: "About us",
          name: "About us",
          price: "",
          type: "about",
          desc: "About us",
        },
        {
          id: 40011,
          text: "FAQs",
          name: "FAQ",
          price: "",
          type: "faqs",
          desc: "FAQ",
        },
      ],
      backtostart: false,
      img: "/doctorassistant/dia.jpg",
      slideimg: "/doctorassistant/dia.jpg",
      display: "Natasha",
      position: "Customer Executive",
      text: `<p>${getPakistanGreeting()}! I&rsquo;m Natasha, your virtual agriculture expert assistant  at <strong>WEB<span style='color: #4fc4cc;'>DOC</span></strong>. Give me just a moment while I fetch your details, this won&rsquo;t take long!</p>`,
    };

    setMessages((prevMessages) => [...prevMessages, item]);
    // setIsLoading(true)
    setLoading(true);
  }, []);

  const activePackage = () => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    sessionUser["package"] = null;
    sessionUser["applicationUserId"] = "27C62D9C-AB40-450C-A6CE-7851F47190FA";
    const updatedItem = JSON.stringify(sessionUser);
    sessionStorage.setItem("user", updatedItem);
    console.log(sessionStorage.getItem("user"));
  };

  // Scroll to the bottom whenever messages are updated
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  useEffect(() => {
    if (diseasename) {
      // Only call loadData if diseasename has been updated
      loadData("diseases", null, null);
    }
  }, [diseasename]);

  // Load modal data (e.g., faqs, about, doctor) based on type
  const loadData = async (type, price, pid, msg) => {
    //alert(diseasename)
    const newMessage = await getAgriChatData(
      type,
      price,
      pid,
      diseasename,
      msg,
    );

    setLoading(false);

    // if (newMessage.modal.text == "") {
    //   //alert ("empty");
    // }

    //alert(newMessage.modal);
    setMessages((prevMessages) => [...prevMessages, newMessage.modal]);

    if (newMessage.doctorassistant) {
      setSideImage(newMessage.doctorassistant.img);
      setLoading(true);
      //setLoading(true);
      setTimeout(() => {
        let image = "";
        if (newMessage.doctorassistant.img) {
          image = newMessage.doctorassistant.img;
        }
        setMessages((prevMessages) => [
          ...prevMessages,
          newMessage.doctorassistant,
        ]);

        if (
          newMessage.doctorassistant.options &&
          newMessage.doctorassistant.options.length > 0
        ) {
          newMessage.doctorassistant.options.forEach((option) => {
            option.isOption = true;
            option.sender = "Receiver";
            setMessages((prevMessages) => [...prevMessages, option]);
          });

          console.log(messages);
        }
        setLoading(false);
      }, 2000);
    }

    if (newMessage.modal.options && newMessage.modal.options.length > 0) {
      newMessage.modal.options.forEach((option) => {
        option.isOption = true;
        option.sender = "Receiver";
        setMessages((prevMessages) => [...prevMessages, option]);
      });

      // console.log(messages);
    }
  };

  const startagain = async (type) => {
    let item = {
      id: 1,
      name: "Start Text",
      type: "text",
      options: [
        {
          id: 40012,
          text: "Connect to the Doctor",
          name: "Connect to the Doctor",
          price: "",
          type: "doctor",
          desc: "I’d like to connect with a doctor.",
        },
        {
          id: 40012,
          text: "About us",
          name: "About us",
          price: "",
          type: "about",
          desc: "About us",
        },
        {
          id: 40011,
          text: "FAQs",
          name: "FAQ",
          price: "",
          type: "faqs",
          desc: "FAQ",
        },
      ],
      backtostart: false,
      slideimg: "",
      img: "/doctorassistant/dia.jpg",
      slideimg: "/doctorassistant/dia.jpg",
      display: "Natasha",
      position: "Customer Executive",
      text: `<p>${getPakistanGreeting()}! I&rsquo;m Natasha, your virtual health assistant at <strong>WEB<span style='color: #4fc4cc;'>DOC</span></strong>. Give me just a moment while I fetch your details, this won&rsquo;t take long!</p>`,
    };
    setShowConsultation(false);
    setdiseasename(null);
    setMessages([]); // Clears all messages
    setShowList(false);
    setMessages((prevMessages) => [...prevMessages, item]);
    await loadData(type);
  };

  // Handle selection of an option
  const handleOptionSelect = async (msg) => {
    setLoading(true); // Show loader first

    // Remove all option messages before doing anything
    setMessages((prevMessages) => prevMessages.filter((msg) => !msg.isOption));
    if (msg.type !== "calltype") {
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: "You", text: msg.desc },
      ]);
    }

    // Simulate delay and then show the message after the loader
    setTimeout(() => {
      if (msg.type === "calltype") {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            sender: "Receiver",
            slideimg: "/doctorassistant/dia.jpg",
            text: "Please hold on while I find an available expert for you.",
          },
        ]);
        setShowList(true);
        setLoading(false); // Show doctor list if calltype is selected
      } else if (msg.type === "consultation") {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            sender: "Receiver",
            slideimg: "/doctorassistant/dia.jpg",
            text: "Please hold on while We are preparing agri expert consultation for you.",
          },
        ]);
        setShowConsultation(true);
        setLoading(false);
      } else {
        if (msg.type == "diseases") {
          //alert(msg.desc)
          setdiseasename(msg.desc);
          //diseasename=msg.desc;
        } else {
          loadData(msg.type, msg.price, msg.id, msg);
        }
      }

      //setLoading(false); // Hide loader after the messages are updated
    }, 2000); // 2 second delay
  };

  return (
    <>
      <Header_packages_chat title="AgriExpert" />
      {/* <img src="/doctorassistant/dia.jpg" alt=""></img> */}
      <Container>
        <Row>
          <Col className="chat_container" md={12}>
            <div className="chat_window pt-2">
              <div className="messages">
                {messages.map((msg, index) => (
                  <>
                    {/* this is main image */}
                    {msg?.img && msg?.img !== "" && (
                      <div key={index} className="row mt-2">
                        <div className="col-12 text-center">
                          <img
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                            class="rounded-circle img-fluid"
                            src={msg.img}
                            alt=""
                          ></img>
                          <br></br>
                          <strong class="mt-2">{msg.display}</strong>
                          <br></br>
                          <small>{msg.position}</small>
                        </div>
                      </div>
                    )}

                    <div class="d-flex">
                      {/* this is side image on all chats*/}
                      {!msg.isOption && msg.sender !== "You" && (
                        <div class="flex-shrink-0 mt-2">
                          <img
                            src={msg.slideimg}
                            alt="customer executive"
                            style={{
                              width: "25px",
                              height: "30px",
                              objectFit: "cover",
                            }}
                            class="rounded-circle img-fluid"
                          />
                        </div>
                      )}

                      {/* this is chat started*/}
                      <div
                        style={{ minWidth: "30%" }}
                        className={
                          msg.sender !== "You"
                            ? "flex-grow-1 ms-2"
                            : "ms-auto justify-content-end"
                        }
                      >
                        {msg.text && msg.text !== "" && !msg.isOption && (
                          <div
                            key={index}
                            className={`message shadow-sm ${
                              msg.sender === "You" ? "sender" : "receiver"
                            }`}
                          >
                            <div className="message_text">
                              {msg.sender !== "Receiver" && (
                                <div className="message_sender"></div>
                              )}

                              {/* Handle truncated or full message based on paragraph length */}
                              <div
                                className={`message-content ${
                                  expandedMessages[index] ? "expanded" : ""
                                }`}
                              >
                                {/* Calculate paragraph length excluding HTML tags */}
                                {(() => {
                                  const paragraphLength = msg.text.replace(
                                    /<[^>]*>/g,
                                    "",
                                  ).length;
                                  if (
                                    paragraphLength > 240 &&
                                    !expandedMessages[index]
                                  ) {
                                    // If the paragraph length is greater than 240 and not expanded, truncate
                                    return (
                                      <>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              msg.text.substring(0, 240) +
                                              "...",
                                          }}
                                        />
                                        {/* Read More Button */}
                                        <a
                                          href="#"
                                          className="text-decoration-none read-more-btn"
                                          onClick={() =>
                                            handleReadMoreClick(index)
                                          }
                                        >
                                          Read More
                                        </a>
                                      </>
                                    );
                                  } else {
                                    // If paragraph length is less than 300 or expanded, show full message
                                    return (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: msg.text,
                                        }}
                                      />
                                    );
                                  }
                                })()}
                              </div>
                            </div>

                            {/* 'Start Again' Button */}
                            {msg.backtostart && (
                              <a
                                href="#"
                                className="text-decoration-none"
                                style={{ cursor: "pointer" }}
                                onClick={() => startagain("start")}
                              >
                                Start Again
                              </a>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ))}
                {loading && <ChatLoader />}
              </div>
              <div className="row">
                {messages.map((msg, index) => (
                  <>
                    {msg.isOption && (
                      <>
                        {msg.price && msg.price ? (
                          <div
                            className="col-12 col-md-6 d-flex justify-content-center gy-2"
                            onClick={() => handleOptionSelect(msg)}
                          >
                            <Card
                              className="border border-success"
                              style={{
                                width: "30rem",
                                height:
                                  msg.type === "paymentProduct"
                                    ? "16rem"
                                    : "12rem",
                              }}
                            >
                              <Card.Body className="text-center d-flex flex-column">
                                <Card.Title className="text-truncate">
                                  {msg.name}
                                </Card.Title>

                                <Card.Text className="mt-2">
                                  <strong style={{ fontSize: "15px" }}>
                                    {msg.isfree ? (
                                      <>
                                        <span className="badge bg-success">
                                          Free
                                        </span>
                                      </>
                                    ) : (
                                      <span>
                                        Rs {msg.price}
                                        {msg.badge && (
                                          <span
                                            className="fw-light"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {msg.badge}
                                          </span>
                                        )}
                                      </span>
                                    )}
                                  </strong>
                                </Card.Text>

                                <span
                                  className="text-muted text-start card-description"
                                  dangerouslySetInnerHTML={{ __html: msg.desc }}
                                />
                              </Card.Body>
                            </Card>
                          </div>
                        ) : (
                          <div key={index} className={`col-12`}>
                            <div className="p-0">
                              <Button
                                variant="secondary"
                                style={{ backgroundColor: "#1bb367" }}
                                className="border-0 w-75 mb-2 chatOptions" // Use 'me-2' for spacing between buttons
                                onClick={() => handleOptionSelect(msg)}
                              >
                                <>
                                  {!msg.price ? (
                                    <p className="mb-0">{msg.name}</p>
                                  ) : null}{" "}
                                </>
                              </Button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ))}
                <div ref={messagesEndRef} />
              </div>

              {showList && (
                <AgriChatDoctorList
                  messages={messages}
                  setMessages={setMessages}
                  setShowList={setShowList}
                />
              )}
              {showConsultation && (
                <AgriChatPrescription
                  messages={messages}
                  setMessages={setMessages}
                  setShowConsultation={setShowConsultation}
                />
              )}
            </div>
            {/* Button triggers to load data */}
            <Row className="py-3 justify-content-center">
              {/* <Col md={5} sm={6} className="col-6"> */}
              {/*                 
                <Button
                  className="w-100 chatOptions rounded-pill"
                  onClick={() => setShowList(true)}
                >
                  Load Doctors List
                </Button>
              </Col> */}
              {/* <Col md={5} sm={6} className="col-6">
                <Button
                  className="w-100 chatOptions rounded-pill"
                  onClick={activePackage}
                >
                  De-activate Package
                </Button>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AgriDocChat;
